import { useMemo } from 'react';
import { gqlTalentUnionEnum as TALENT_UNION } from '@minecraft.graphql-types';
import { useUnionTypesText } from '@blocs.common';

export const useUnionStatusOptions = () => {
  const getUnionTypeText = useUnionTypesText();

  return useMemo(
    () => [
      { value: TALENT_UNION.NON_UNION, label: getUnionTypeText(TALENT_UNION.NON_UNION) },
      { value: TALENT_UNION.ACTRA, label: getUnionTypeText(TALENT_UNION.ACTRA) },
      { value: TALENT_UNION.AEA, label: getUnionTypeText(TALENT_UNION.AEA) },
      { value: TALENT_UNION.CAEA, label: getUnionTypeText(TALENT_UNION.CAEA) },
      { value: TALENT_UNION.EQUITY, label: getUnionTypeText(TALENT_UNION.EQUITY) },
      { value: TALENT_UNION.MEAA, label: getUnionTypeText(TALENT_UNION.MEAA) },
      { value: TALENT_UNION.ELIGIBLE, label: getUnionTypeText(TALENT_UNION.ELIGIBLE) },
      { value: TALENT_UNION.FICORE, label: getUnionTypeText(TALENT_UNION.FICORE) },
      { value: TALENT_UNION.MEMBER, label: getUnionTypeText(TALENT_UNION.MEMBER) },
      { value: TALENT_UNION.UBCP_ACTRA, label: getUnionTypeText(TALENT_UNION.UBCP_ACTRA) },
      { value: TALENT_UNION.UDA, label: getUnionTypeText(TALENT_UNION.UDA) },
    ],
    [getUnionTypeText]
  );
};
